<div
    class="date-list"
    role="listbox"
    [attr.aria-label]="ariaLabel"
    [attr.aria-activedescendant]="getOptionId(activeIndex)"
    (keydown)="onKeydown($event)">
    <cdk-virtual-scroll-viewport
        [itemSize]="itemSize"
        [minBufferPx]="minBufferPx"
        [maxBufferPx]="maxBufferPx"
        class="date-viewport">
        <button
            *cdkVirtualFor="let date of renderedDates; let index = index; trackBy: trackByDate"
            type="button"
            [id]="getOptionId(index)"
            [attr.aria-selected]="selectedDate === date.utcDate"
            [tabIndex]="index === activeIndex ? 0 : -1"
            class="date-item"
            [class.selected]="selectedDate === date.utcDate"
            role="option"
            (click)="selectDate(date, index)"
            (focus)="onFocus(index)">
            <span class="date-label">{{date.longDate}}</span>
            <mat-icon class="date-radio" aria-hidden="true">{{selectedDate === date.utcDate ? 'radio_button_checked' : 'radio_button_unchecked'}}</mat-icon>
        </button>
    </cdk-virtual-scroll-viewport>
</div>
